import DatePicker from "components/form/date-picker";
import { formatMessage } from "lib/globalize-util";
import moment from "moment";
import * as React from "react";
import { PureComponent } from "react";
import { DATATEST } from "constants/integration";

const styles = {
    base: {
        maxHeight: "0px",
        opacity: 0,
        overflow: "hidden",
        transition: "all 0.2s ease-out",
    },
    baseShow: {
        maxHeight: "114px",
        opacity: 1,
    },
    clearDate: {
        top: "22px",
        right: "7px",
    },
    container: {
        display: "flex",
        margin: "0 -12px",
        padding: "12px 0 0",
        maxWidth: "340px",
    },
    input: {
        padding: "0 15px",
    },
    requiredLabel: {
        fontWeight: "bold",
    },
    shipDate: {
        padding: "0 12px",
        width: "50%",
    },
};

const MyDatePicker = (props) => {
    return (
        <DatePicker
            style={styles.shipDate}
            large={true}
            inputStyle={styles.input}
            {...props}
            clearStyle={styles.clearDate}
        />
    );
};

interface IProps {
    minimum_delivery_window?: any;
    deliveryWindowStart?: any;
    deliveryWindowEnd?: any;
    onChange: (shipStart: moment.Moment, shipEnd: moment.Moment) => void;
    requireCatalogDates: boolean;
}

export class DeliveryDates extends PureComponent<IProps, any> {
    render() {
        const { minimum_delivery_window, deliveryWindowStart, deliveryWindowEnd, requireCatalogDates } = this.props;
        const shipStart = deliveryWindowStart || null;
        let shipEnd;
        if (deliveryWindowEnd || shipStart) {
            shipEnd = deliveryWindowEnd || shipStart.add(minimum_delivery_window, "days");
        }

        return (
            <div style={{ ...styles.base, ...styles.baseShow }} data-test={DATATEST.CATALOG.DELIVERY_DATES}>
                <div style={styles.container}>
                    <MyDatePicker
                        label={formatMessage("Delivery Start")}
                        name="ship-start"
                        data-test={DATATEST.CATALOG.DELIVERY_START_PICKER}
                        value={shipStart}
                        onChange={this.handleChange.bind(this, "ship-start")}
                        clearable={!requireCatalogDates}
                        labelStyle={requireCatalogDates && !deliveryWindowStart ? styles.requiredLabel : null}
                    />
                    <MyDatePicker
                        label={formatMessage("Delivery End")}
                        name="ship-end"
                        data-test={DATATEST.CATALOG.DELIVERY_END_PICKER}
                        value={shipEnd}
                        onChange={this.handleChange.bind(this, "ship-end")}
                        clearable={!requireCatalogDates}
                        labelStyle={requireCatalogDates && !deliveryWindowStart ? styles.requiredLabel : null}
                    />
                </div>
            </div>
        );
    }

    private handleChange(field, e, date) {
        const { onChange, minimum_delivery_window, deliveryWindowStart, deliveryWindowEnd } = this.props;
        let shipStart;
        let shipEnd;
        if (date) {
            if (field === "ship-start") {
                shipStart = date;
                const minShipEnd = shipStart.clone().add(minimum_delivery_window, "days");
                if (!deliveryWindowEnd || deliveryWindowEnd.isBefore(minShipEnd)) {
                    shipEnd = minShipEnd;
                }
            } else {
                shipEnd = date;
                shipStart = deliveryWindowStart;
                const minShipStart = shipEnd.clone().subtract(minimum_delivery_window, "days");
                if (!shipStart || minShipStart.isBefore(shipStart)) {
                    shipStart = minShipStart;
                }
            }
        } else {
            shipStart = null;
            shipEnd = null;
        }

        onChange(shipStart, shipEnd);
    }
}
